<ng-container *ngIf="vm$() as vm">
  <a mat-button [matMenuTriggerFor]="chatMenu" class="titleMedium colorNeutral80">{{vm.chatListMode | titlecase}} chats <mat-icon iconPositionEnd>expand_more</mat-icon></a>
  <mat-menu #chatMenu="matMenu">
    <button *ngFor="let chatType of chatTypes" [disabled]="vm.chatListMode === chatType" mat-menu-item (click)="changeChatListMode(chatType)">
      {{chatType | titlecase}} chats
    </button>
  </mat-menu>
</ng-container>
